import React, { useState } from 'react'
import Layout from '../../Layout';
import { Button, Input } from '../../components/Form';
import { FaSave } from 'react-icons/fa';
import Container from '../../components/Container';
import { editProfile } from '../../api/profile';
import { useAppSelector } from '../../store';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function Profile() {
  const userData = useAppSelector((state) => state.userData);
  const navigate = useNavigate(); // Import useNavigate correctly
  // console.log(userData)

  const [profile, setProfile] = useState({
    // Initialize profile with userData
    ...userData,
  });

  const handleChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    try {
      // user
      if (!profile.firstname.trim() || !profile.lastname.trim()) {
        toast.error("First Name and Last Name are required");
        return;
      }
      const data = {
        firstname: profile.firstname,
        lastname: profile.lastname
      };
      console.log(data);
      const updatedProfile = await editProfile(data);
      console.log(updatedProfile); // Add this line to check the data
      setProfile((prevProfile) => ({ ...prevProfile, ...updatedProfile }));
      toast.success('Profile updated successfully!');
    } catch (error) {
      toast.error('Error updating profile:', error.message);
    }
  };

  return (
    <Layout>
      <Container className={'rounded-xl'}>
        <div className="grid col-span-12">
          <Input label={'First Name *'} name={'firstname'} color={true} placeholder={'First Name'} type={'text'} value={profile.firstname || (userData.user && userData.user.firstName) || ''} onChange={e => handleChange(e)} />
          <Input label={'Last Name *'} name={'lastname'} color={true} placeholder={'Last Name'} type={'text'} value={profile.lastname || (userData.user && userData.user.lastName) || ''} onChange={e => handleChange(e)} />
          <Input label={'Email'} name={'Email'} color={true} placeholder={'Email'} value={profile.email || (userData.user && userData.user.email) || ''} type={'text'} disabled />
          <Button label={'Save'} color={true} Icon={FaSave} onClick={handleSubmit} />
        </div>
      </Container>
    </Layout>
  )
}

export default Profile;